import React, { act, useState } from 'react';
import './placements.css'
import C2wPlacementCard from '../../../common/C2wHome/placementCard.js/placementCard';
import placementData from './placements.json'
import C2wiInView from '../../../components/C2wHome/courses/inView/inView';
import { Helmet } from 'react-helmet';

function C2wPlacemets() {

    const [activeIndex, setActiveIndex] = useState(null);
    const [flag, setFlag] = useState(false)
    /**
 * @constant renderedPlacementsCards
 * @author Vishal Lohbande
 *
 * Description:
 * - Maps over the `placementData.placements` array to render a list of `C2wPlacementCard` components.
 * - Each `url` in the array is used to construct an image path and passed as the `url` prop.
 * - The image path is prefixed with `/assets/images/placements/`.
 *
 * Usage:
 * - Displays placement images/cards using data from `placementData.placements`.
 *
 * Notes:
 * - Consider adding a unique `key` prop to each component to optimize React rendering.
 * - Ensure that `placementData` and `placementData.placements` are properly loaded to avoid runtime errors.
 */
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleDetails = (index) => {
        setSelectedIndex(index);
        setFlag(true)
    };

    const handleFlag = (flag) => {
        setFlag(flag)
    }

    return (
        <div className='C2wTestimonials_ctn_route'>
            <Helmet>
                    {/* 
                    Purpose: Defines the page title displayed in search results and browser tabs. 
                             It’s one of the most important SEO elements. 
                    */}
                    <title>{`Placements of Core2web Students`}</title>  
            
                    {/* 
                    Purpose: Provides a brief summary of the page content in search results. 
                             While not a direct ranking factor, it influences CTR. 
                    */}
                    <meta name="description" content="Core2web Provides 100% Placement Guidance" />
                    
                    {/* Purpose: Controls indexing and link-following behavior. */}
                    <meta name="robots" content="index, follow" />
                    
                  </Helmet>
            <div className='C2wTestimonials_ctn_sroller'>
                <div className='C2wPlacementsHeading_ctn_hld'>
                    <div className='C2wPlacementsHeading_ctn'>
                        <span className='C2wPlacementsHeadingSpan'>{'12500+ '}</span>
                        {'Students Placed in'}
                        <span className='C2wPlacementsHeadingSpan'>{' 180+ '}</span>
                        {'Companies'}
                    </div>
                </div>
                <div className='C2wPlacemets_ctn_placementsCards_htder'>
                    {/* {renderedPlacementsCards} */}
                    {placementData?.placements?.map((url, index) => (
                        <C2wPlacementCard
                            key={index}
                            onClick={() => handleDetails(index)}
                            index={index} url={`/assets/images/placements/${url}`} />
                    ))}
                </div>
            </div>
            {flag &&
                <C2wiInView
                    placementsArray={placementData?.placements}
                    index={selectedIndex}
                    handleFlag={handleFlag}
                />
            }
        </div>
    )
}

export default C2wPlacemets
